import { get, isEmpty } from "lodash";
import { useQuery } from "shared/hooks/useApi";
import { SUBSCRIPTION } from "utils/api/graphql/queries/subscription";
import { KEYS, RELATIONSHIP } from "utils/constants";
import Navbar from "../Components/Navbar/Navbar";
import View from "./View";

const SocialSecurityNumber = ({
  project,
  onNext,
  onBack,
  tracer,
  currentStatus,
  updateUrl,
}) => {
  const subscriptionId =
    get(project, "fields.currentSubscription") ||
    localStorage.getItem(KEYS.SUBSCRIPTION_ID);
  const { data } = useQuery(SUBSCRIPTION, {
    variables: { where: { id: subscriptionId } },
  });
  const onSubmit = ({ socialSecurityNumber, fields }) => {
    const source = localStorage.getItem(KEYS.SOURCE);
    updateUrl({
      subscriptionId,
      url: get(
        data,
        "subscription.insurancePlan.config.generatedUrl",
        `${process.env.REACT_APP_BASE_URL}/#/public/process/init/${source}`,
      ),
    });
    const relatedPersons = get(project, "contact.relatedPersons", []).filter(
      (_) => _,
    );
    const hasChildren = !!relatedPersons.filter(
      ({ relationship }) => relationship === RELATIONSHIP.CHILD,
    ).length;
    const hasSpouse = !isEmpty(
      relatedPersons.find(
        ({ relationship }) => relationship === RELATIONSHIP.SPOUSE,
      ),
    );
    return onNext({
      payload: {
        contact: {
          id: get(project, "contact.id"),
          socialSecurityNumber,
          fields: {
            ...get(project, "contact.fields"),
            ...fields,
          },
        },
        fields: {
          ...get(project, "fields"),
          hasRelatedPersons: {
            hasChildren,
            hasSpouse,
          },
        },
      },
    });
  };
  return (
    <>
      <Navbar
        project={project}
        currentStatus={currentStatus}
        tracer={tracer}
        showCart
        showProfile
      />
      <View
        contact={get(project, "contact", {})}
        onNext={onSubmit}
        onBack={onBack}
      />
    </>
  );
};

export default SocialSecurityNumber;
